import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AESService {

  private key = CryptoJS.enc.Utf8.parse("mySuperSecretK12"); // 16 chars
  private iv = CryptoJS.enc.Utf8.parse("mySuperSecretIV1");  // 16 chars

  encrypt(value: string): string {
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value),
      this.key,
      {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    return encrypted.toString(); // Base64 string same as Java
  }

  decrypt(cipherText: string): string {
    const decrypted = CryptoJS.AES.decrypt(
      cipherText,
      this.key,
      {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    return CryptoJS.enc.Utf8.stringify(decrypted);
  }


}
